import React, { Fragment, useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { validateTransactionalAuthCode } from "../services/api/authorizations";
import { getRedirectionData } from "../services/api/entities";
import { setSessionRedirectionData } from "../utils/handleRedirectionData";
import { setRedirectionData as setRedirectionDataAPI } from "../services/api/entities";
import { showToast } from "../utils/helper";
import { useQuery } from "../utils/hooks/useQuery";

export const Redirection = React.memo(() => {
  const [redirectTo, setRedirectTo] = useState(false);
  let query = useQuery();

  useEffect(() => {
    const auth_code = query.get("auth_code");
    const pre_pin_validation_token = query.get("pre_pin_validation_token");

    getRedirectionData({ redirectionId: pre_pin_validation_token })
      .then(({ response: redirectionResponse }) => {
        if (redirectionResponse.found) {
          const redirectData = redirectionResponse.redirectionData;

          validateTransactionalAuthCode({ auth_code })
            .then(({ response }) => {
              if (!response.pin_valid) {
                showToast("Código de autorización inválido.");
                setRedirectTo({
                  url: "/",
                  data: {},
                });
              } else {
                setRedirectionDataAPI({});

                if (redirectData.id === pre_pin_validation_token) {
                  switch (redirectData.data.type) {
                    case "Authorization":
                      setRedirectTo({
                        url: "/authorizations",
                        data: redirectData.data.payload,
                      });
                      break;
                    case "FirstAccess":
                    case "InternalMessage":
                    case "Popup":
                    case "Contract":
                      break;
                    default:
                      showToast("Tipo de autorización incorrecto.");
                      setRedirectTo({
                        url: "/",
                        data: {},
                      });
                  }
                } else {
                  showToast("Código de redirección inválido.");
                  setRedirectTo("/");
                }
              }
            })
            .catch((err) => {
              console.error(err);
              showToast("Error validando código de autorización.");
              setRedirectTo("/");
            })
            .finally(() => {
              setSessionRedirectionData(false);
            });
        } else {
          showToast("Error obteniendo información de redirección", true);
          setRedirectTo({
            url: "/",
            data: {},
          });
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Error obteniendo información de redirección", true);
      });
  }, []);

  if (redirectTo) {
    return (
      <Redirect
        to={{
          pathname: redirectTo.url,
          state: { redirectionData: redirectTo.data },
        }}
      />
    );
  }

  return (
    <Fragment>
      <Row>
        <Col>
          <h1>Redireccionando...</h1>
        </Col>
      </Row>
    </Fragment>
  );
});
